import React from 'react'

const About = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">O nama</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Teniski klub Vamos je osnovan 2016. godine. Klub su osnovali istinski zaljubljenici u tenisku igru, nakon godina i godina prikupljanja iskustava i znanja koje sada želimo svakodnevno prenositi drugim entuzijastima i ljubiteljima tenisa.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About



// WEBPACK FOOTER //
// ./src/components/About.js